<script>
    import DataTable, {Body, Head, Row, Cell} from "@smui/data-table";

    import Currency from "./Currency.svelte";
    import WarningExpense from "./WarningExpense.svelte";

    import {globalState} from '../store/store.js';

    /** @type (array) result array from API */
    export let result = undefined;

    function getValue(result, key, period = "monthly") {
        let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        return result[key] * periodFactor;
    }

    let nbDays = 21;
    for (const [key, value] of Object.entries($globalState)) {
        if ('h' === key) {
            nbDays = value;
            break;
        }
    }
</script>
<WarningExpense {result}/>
<DataTable table$aria-label="slidemonth-one" style="width: 100%;">
    <Head>
        <Row>
            <Cell as="th" colspan="2" style="text-align: center">
                <span class="orange">
                    Mensuel
                    <br/>
                    sur {nbDays} jours
                </span>
            </Cell>
        </Row>
    </Head>
    <Body>
    <Row style="height: 25px;">
        <Cell>TJM</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "dailyRate")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Facturation</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "invoiceAmount")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Brut</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "totalBaseGross")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">*</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayBeforePAS")}/>
        </Cell>
    </Row>
    <!--{#if privateVersion}-->
    <Row style="height: 25px;">
        <Cell>PAS</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "pasAmount")}/>
        </Cell>
    </Row>
    <Row style="height: 25px;">
        <Cell>Salaire Net<span class="super">**</span> + Frais</Cell>
        <Cell style="text-align: right">
            <Currency number={getValue(result, "netToPayAfterPAS")}/>
        </Cell>
    </Row>
    <!--{/if}-->
    </Body>
</DataTable>
